import axios from "axios";

//创建请求
let createServe = (config) => {
  const serve = axios.create({
    baseURL: '/api',
    // timeout: 5000 //超时
  });

  //请求拦截器
  serve.interceptors.request.use(
    (config) => {
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  //响应拦截器
  serve.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  return serve(config);
};
export default createServe; //导出创建服务的方法
